import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import InsightDetail from "@/pages/InsightDetail";
import ServiceDetail from "@/pages/ServiceDetail";
import ProductDetail from "@/pages/ProductDetail";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import LandingPage from "@/pages/LandingPage";
import { LanguageProvider } from "@/i18n";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/works/:slug" element={<CaseStudyDetail />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/jasa/:slug" element={<LandingPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </LanguageProvider>
    </div>
  );
}

export default App;
